<template>
  <div class="parentgoback">
    <div class="btn" v-tap="{methods:goback}">

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    methods: {
      goback () {
        this.$emit('exit');
        this.$router.goBack();
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .parentgoback{
    padding-left: px2rem(261);
    padding-top: px2rem(44);
  }
  .btn{
  @include bg-img('../assets/img/parentRecord/goback');
    width: px2rem(242);
    height: px2rem(80);
  }
</style>



// WEBPACK FOOTER //
// VGoBackBtn.vue?f5557aca